import React, { useState, useEffect } from "react";
import "./ShopDetails.css";
import "../Filters/Filter.css";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../Features/Cart/cartSlice";
import Filter from "../Filters/Filter";
import { Link } from "react-router-dom";
import StoreData from "../../../Data/StoreData";
import { FiHeart } from "react-icons/fi";
import { FaStar } from "react-icons/fa";
import { IoFilterSharp, IoClose } from "react-icons/io5";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6";
import { FaCartPlus } from "react-icons/fa";
import toast from "react-hot-toast";
import { addToWishList, removeFromWishList } from "../../../Features/Wishlist/wishListSlice";



const ShopDetails = () => {
  const dispatch = useDispatch();
  const wishlistItems = useSelector((state) => state.wishlist.items);
  const cartItems = useSelector((state) => state.cart.items);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOption, setSortOption] = useState("default");
  const productsPerPage = 9;

  // Filter states
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedMetals, setSelectedMetals] = useState([]);
  const [selectedSizes, setSelectedSizes] = useState([]);
  const [priceRange, setPriceRange] = useState([0, 6000]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  

  const isInWishlist = (productID) => {
    return wishlistItems.some(item => item.productID === productID);
  };

  

  // Filtered products state
  const [filteredProducts, setFilteredProducts] = useState(StoreData);

  // Apply all filters
  useEffect(() => {
    let result = [...StoreData];

    // Category filter
    if (selectedCategory !== "All") {
      result = result.filter(product => {
        return product.category?.toLowerCase() === selectedCategory.toLowerCase();
      });
      console.log("Filtered results:", result); // See what products made it through
    }

    // Metal filter
    if (selectedMetals.length > 0) {
      result = result.filter(product => 
        selectedMetals.includes(product.metalType)
      );
    }

    // Size filter
    if (selectedSizes.length > 0) {
      result = result.filter(product =>
        selectedSizes.includes(product.size)
      );
    }

    // Price filter
    result = result.filter(product => {
      if (isPreciousMetal(product.metalType)) {
        return true;
      }
      return product.productPrice >= priceRange[0] && 
             product.productPrice <= priceRange[1];
    });

    // Brand filter
    if (selectedBrands.length > 0) {
      result = result.filter(product =>
        selectedBrands.includes(product.brand)
      );
    }

    // Apply sorting
    const sortedResult = sortProducts(result, sortOption);
    
    setFilteredProducts(sortedResult);
    setCurrentPage(1); // Reset to first page when filters change
  }, [selectedCategory, selectedMetals, selectedSizes, priceRange, selectedBrands, sortOption]);

  const handleFilterChange = {
    category: (category) => setSelectedCategory(category),
    metals: (metals) => setSelectedMetals(metals),
    sizes: (sizes) => setSelectedSizes(sizes),
    price: (range) => setPriceRange(range),
    brands: (brands) => setSelectedBrands(brands),
  };

  const handleWishlistClick = (product) => {
    if (isInWishlist(product.productID)) {
      dispatch(removeFromWishList(product));
      toast.success('Removed from wishlist', {
        duration: 2000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
    } else {
      dispatch(addToWishList(product));
      toast.success('Added to wishlist', {
        duration: 2000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };
  const isPreciousMetal = (metalType) => {
    const preciousMetals = ['Gold', 'Rose Gold', 'Platinum', 'White Gold'];
    return preciousMetals.includes(metalType);
  };

  const handleAddToCart = (product) => {
    // Check if the product is made of precious metal
    if (isPreciousMetal(product.metalType)) {
      // For mobile cart icon clicks, show warning
      toast.error("Please contact us for current pricing on precious metal items", {
        duration: 3000,
        style: {
          backgroundColor: "#ff4b4b",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#ff4b4b",
        },
      });
      return;
    }

    // Original cart logic for non-precious metals
    const productInCart = cartItems.find(
      (item) => item.productID === product.productID
    );

    if (productInCart && productInCart.quantity >= 20) {
      toast.error("Product limit reached", {
        duration: 2000,
        style: {
          backgroundColor: "#ff4b4b",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#ff4b4b",
        },
      });
    } else {
      dispatch(addToCart(product));
      toast.success(`Added to cart!`, {
        duration: 2000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
    }
  };

  const sortProducts = (products, sortOption) => {
    const sortedProducts = [...products];
    
    switch (sortOption) {
      case "bestSelling":
        // Show ONLY best-selling products (category "B")
        return sortedProducts.filter(p => p.productCategory === "B");
        
      case "featured":
        // Show ONLY featured products (category "F"), excluding sale items
        return sortedProducts.filter(p => p.productCategory === "F" && !p.isOnSale);
        
      case "onSale":
        // Show ONLY products marked as on sale
        return sortedProducts.filter(p => p.isOnSale === true);
        
      case "a-z":
        return sortedProducts.sort((a, b) => 
          a.productName.toLowerCase().localeCompare(b.productName.toLowerCase())
        );
        
      case "z-a":
        return sortedProducts.sort((a, b) => 
          b.productName.toLowerCase().localeCompare(a.productName.toLowerCase())
        );
        
        case "lowToHigh":
          return sortedProducts.sort((a, b) => {
            if (!a.productPrice) return 1;
            if (!b.productPrice) return -1;
            return a.productPrice - b.productPrice;
          });
          
        case "highToLow":
          return sortedProducts.sort((a, b) => {
            if (!a.productPrice) return -1;
            if (!b.productPrice) return 1; 
            return b.productPrice - a.productPrice;
          });
        
      default:
        return sortedProducts;
    }
  };

  // Pagination
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  console.log("Pagination indexes:", {
    first: indexOfFirstProduct,
    last: indexOfLastProduct,
    totalProducts: filteredProducts.length,
    currentPage
  });
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);
  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      scrollToTop();
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      scrollToTop();
    }
  };

  const handlePageChange = (pageNumber) => {
    console.log("Changing to page:", pageNumber); // Debug log
    setCurrentPage(pageNumber);
    scrollToTop();
  };

  return (
    <>
      <div className="shopDetails">
        <div className="shopDetailMain">
          <div className="shopDetails__left">
            <Filter 
              selectedCategory={selectedCategory}
              selectedMetals={selectedMetals}
              selectedSizes={selectedSizes}
              priceRange={priceRange}
              selectedBrands={selectedBrands}
              onFilterChange={handleFilterChange}
            />
          </div>
          <div className="shopDetails__right">
            <div className="shopDetailsSorting">
              <div className="shopDetailsBreadcrumbLink">
                <Link to="/" onClick={scrollToTop}>
                  Home
                </Link>
                &nbsp;/&nbsp;
                <Link to="/shop">The Shop</Link>
              </div>
              <div className="filterLeft" onClick={toggleDrawer}>
                <IoFilterSharp />
                <p>Filter</p>
              </div>
              <div className="shopDetailsSort">
              <select
                  name="sort"
                  id="sort"
                  value={sortOption}
                  onChange={(e) => setSortOption(e.target.value)}
                >
                  <option value="default">Default Sorting</option>
                  <option value="bestSelling">Best Selling</option>
                  <option value="featured">Featured</option>
                  <option value="onSale">On Sale</option>
                  <option value="a-z">Alphabetically, A-Z</option>
                  <option value="z-a">Alphabetically, Z-A</option>
                  <option value="lowToHigh">Price, Low to High</option>
                  <option value="highToLow">Price, High to Low</option>
              </select>
              </div>
            </div>
            
            {/* Products Grid */}
            <div className="shopDetailsProducts">
              {currentProducts.length > 0 ? (
                <div className="shopDetailsProductsContainer">
                  {currentProducts.map((product) => (
                    <div className="sdProductContainer" key={product.productID}>
                      <div className="sdProductImages">
                      <Link to={`/product/${product.productID}`} onClick={scrollToTop}>
                        <img src={product.frontImg} alt="" className="sdProduct_front" />
                        <img src={product.backImg} alt="" className="sdProduct_back" />
                      </Link>
                      {isPreciousMetal(product.metalType) ? (
                        <Link 
                        to="/contact" >
                          <h4 >
                            Contact for Price
                          </h4>
                        </Link>  
                        ) : (
                          <h4 onClick={() => handleAddToCart(product)}>
                            Add to Cart
                          </h4>
                        )}
                      </div>
                      <div
                        className="sdProductImagesCart"
                        onClick={() => handleAddToCart(product)}
                      >
                        <FaCartPlus />
                      </div>
                      <div className="sdProductInfo">
                        <div className="sdProductCategoryWishlist">
                          <p>{product.category}</p>
                          <FiHeart
                            onClick={() => handleWishlistClick(product)}
                            style={{
                              color: isInWishlist(product.productID) ? "red" : "#767676",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                        <div className="sdProductNameInfo">
                        <Link to={`/product/${product.productID}`} onClick={scrollToTop}>
                          <h5>{product.productName}</h5>
                        </Link>
                        <div className="flex items-center">
                        {isPreciousMetal(product.metalType) ? (
                            <span style={{ color: "#767676", fontWeight: "500" }}>
                              Price on inquiry
                            </span>
                          ) : (
                            <>
                              {product.isOnSale ? (
                                <>
                                  <span style={{ color: "#029e06", fontWeight: "500" }}>
                                    ${product.productPrice}
                                  </span>
                                  &nbsp;
                                  <span
                                    style={{
                                      color: "#767676",
                                      textDecoration: "line-through",
                                      textDecorationThickness: "1px"
                                    }}
                                  >
                                    ${product.originalPrice}
                                  </span>
                                </>
                              ) : (
                                <span style={{ color: "#767676" }}>
                                  ${product.productPrice}
                                </span>
                              )}
                            </>
                          )}
                          </div>
                          <div className="sdProductRatingReviews">
                            <div className="sdProductRatingStar">
                              {[...Array(5)].map((_, index) => (
                                <FaStar
                                  key={index}
                                  color={index < product.stars ? "#FEC78A" : "#C4C4C4"}
                                  size={10}
                                />
                              ))}
                            </div>
                            <span
                            className={product.isOnSale ? "red-text" : ""}
                            style={{
                              color: product.isOnSale ? "#029e06" : "#767676",
                              fontWeight: product.isOnSale ? "450" : "normal"
                            }}
                          >
                            {product.productReviews}
                          </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{
                  width: "calc(100% - 40px)", // Subtract padding from width
                  maxWidth: "100%",
                  textAlign: "center",
                  padding: "20px",
                  fontSize: "clamp(1rem, 3vw, 1.2rem)", // Responsive font size
                  color: "#666",
                  backgroundColor: "#f9f9f9",
                  borderRadius: "8px",
                  margin: "20px auto", // Changed to auto for horizontal centering
                  boxSizing: "border-box" // Ensure padding is included in width calculation
                }}>
                  No products found matching your criteria. Try adjusting your filters.
                </div>
              )}
            </div>

            {/* Pagination */}
            <div className="shopDetailsPagination">
              <div className="sdPaginationPrev">
                <p onClick={handlePrevPage}>
                  <FaAngleLeft />
                  Prev
                </p>
              </div>
              <div className="sdPaginationNumber">
                <div className="paginationNum">
                {Array.from({ length: totalPages }, (_, i) => {
                const pageNum = i + 1;
                return (
                  <p
                    key={pageNum}
                    onClick={() => handlePageChange(pageNum)}
                    className={currentPage === pageNum ? "active" : ""}
                    style={{ 
                      position: 'relative',
                      cursor: 'pointer',
                      fontWeight: currentPage === pageNum ? '600' : '500'
                    }}
                  >
                    {pageNum}
                  </p>
                );
              })}
                </div>
              </div>
              <div className="sdPaginationNext">
                <p onClick={handleNextPage}>
                  Next
                  <FaAngleRight />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Filter Drawer for Mobile */}
      <div className={`filterDrawer ${isDrawerOpen ? "open" : ""}`}>
        <div className="drawerHeader">
          <p>Filter By</p>
          <IoClose onClick={closeDrawer} className="closeButton" size={26} />
        </div>
        <div className="drawerContent">
          <Filter 
            selectedCategory={selectedCategory}
            selectedMetals={selectedMetals}
            selectedSizes={selectedSizes}
            priceRange={priceRange}
            selectedBrands={selectedBrands}
            onFilterChange={handleFilterChange}
          />
        </div>
      </div>
    </>
  );
};

export default ShopDetails;